'use strict';

angular.module('licensure.services')
    .factory('TGTriggerFunctions', ['$http', '$q', function ($http, $q) {
        function get(args) {
            var d = $q.defer();

            $http
                .get(apiLocation + '/api/TGTriggerFunctions', {
                    params: args
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    // handle error
                });

            return d.promise;
        }
        return {
            getInspectionTriggerFunctions: function () {
                return get({ entity: "inspections" });
            },

            getInvestigationTriggerFunctions: function () {
                return get({ entity: "investigations" });
            }
        };
    }])
;